import { Header, useCurrentCompany } from '@employ-engage/common-components';
import { Outlet, useLocation, matchPath } from 'react-router-dom';
import { Company } from '@employ-engage/data';

/* eslint-disable-next-line */
export interface KioskProps {}

export function Kiosk(props: KioskProps) {
  const { currentCompany: company } = useCurrentCompany();
  const { pathname } = useLocation();

  return (
    <div>
      <Header
        isMultiLanguageEnabled
        hideLogo={matchPath('/:friendlyCompanyId/form', pathname) !== null}
        rightSide={
          (company as Company)?.logoUrl && (
            <div className="bg-white dark:bg-white rounded-2xl">
              <img
                className="h-16 sm:h-32"
                src={(company as Company)?.logoUrl}
                alt={(company as Company)?.name + ' logo'}
              />
            </div>
          )
        }
      />
      <div className="px-0 sm:px-14">
        <Outlet />
      </div>
    </div>
  );
}

export default Kiosk;
